import { observer } from 'mobx-react-lite'

import { useGlobalCopyStore } from '../../common'

import { calculateFinstrongScoreStatus } from '../util/finstrongUtils'

import { DialScoreCard } from './shared/DialScoreCard'

export interface FinacialStrengthGraphProps {
  arcRadius: number
  size?: 'L' | 'M' | 'SM'
  healthScore: number
  footerCenterContent?: string | number
  margin?: { top?: number; right?: number; left?: number; bottom?: number }
}
export const FinancialStrengthGraph = observer(
  ({
    arcRadius,
    size = 'L',
    healthScore,
    footerCenterContent,
    margin,
  }: FinacialStrengthGraphProps) => {
    const healthScoreData = [
      { id: 1, label: 'Group A', value: 25 },
      { id: 2, label: 'Group B', value: 25 },
      { id: 3, label: 'Group C', value: 25 },
      { id: 4, label: 'Group D', value: 25 },
    ]
    const { finstrong: copy } = useGlobalCopyStore()

    const healthScoreStatus = calculateFinstrongScoreStatus(healthScore, copy)

    return (
      <DialScoreCard
        arcRadius={arcRadius}
        dialScoreData={healthScoreData}
        footerCenterContent={
          size === 'L' ? copy.footer_center_content_updated_just_now : footerCenterContent
        }
        healthScore={healthScore}
        healthScoreStatus={healthScoreStatus.status}
        isFinacialStrengthGraph={true}
        margin={margin}
        size={size}
      />
    )
  },
)
